import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const Generosity = (props: SVGProps<SVGSVGElement>) => (
    <svg
        height="89"
        width="90"
        {...props}
        fill="none"
        viewBox="0 0 90 89"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_8201_6095)">
            <circle cx="44.9994" cy="44.5" fill="#DBD6FF" r="44.5" />
            <rect
                fill="white"
                height="5.93333"
                rx="2.96667"
                width="59.3333"
                x="15.3334"
                y="65.2664"
            />
            <path
                d="M44.9995 51.9148C33.5483 51.9148 24.2328 42.5993 24.2328 31.1499C24.2328 19.7004 33.5483 10.3832 44.9995 10.3832C56.4506 10.3832 65.7661 19.6987 65.7661 31.1499C65.7661 42.601 56.4489 51.9148 44.9995 51.9148Z"
                fill="#EEECFF"
            />
            <path
                d="M44.9995 57.6997C33.5483 57.6997 24.2328 48.3842 24.2328 36.9347C24.2328 25.4852 33.5483 16.168 44.9995 16.168C56.4506 16.168 65.7661 25.4835 65.7661 36.9347C65.7661 48.3859 56.4489 57.6997 44.9995 57.6997Z"
                fill="#DBD6FF"
            />
            <path
                d="M44.9995 63.4851C33.5483 63.4851 24.2328 54.1696 24.2328 42.7202C24.2328 31.2707 33.5483 21.9535 44.9995 21.9535C56.4506 21.9535 65.7661 31.269 65.7661 42.7202C65.7661 54.1713 56.4489 63.4851 44.9995 63.4851Z"
                fill="#BEB3FF"
            />
            <g clipPath="url(#clip1_8201_6095)">
                <path
                    d="M44.9996 71.1985C33.5484 71.1985 24.2329 61.883 24.2329 50.4335C24.2329 38.9841 33.5484 29.6669 44.9996 29.6669C56.4507 29.6669 65.7662 38.9824 65.7662 50.4335C65.7662 61.8847 56.449 71.1985 44.9996 71.1985Z"
                    fill="#715AFF"
                />
                <path
                    d="M44.7017 63.0914C44.7017 63.0914 33.1317 55.9658 33.1317 49.5491C33.1317 45.5877 35.9078 42.5225 39.4956 42.5225C41.521 42.5225 43.4294 43.5442 44.7017 45.2052C45.974 43.5442 47.8824 42.5225 49.9079 42.5225C53.4956 42.5225 56.2717 45.5877 56.2717 49.5491C56.2717 55.6127 44.7017 63.0914 44.7017 63.0914Z"
                    fill="#FFD678"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_8201_6095">
                <rect
                    fill="white"
                    height="89"
                    transform="translate(0.499359)"
                    width="89"
                />
            </clipPath>
            <clipPath id="clip1_8201_6095">
                <rect
                    fill="white"
                    height="38.5667"
                    transform="translate(21.6359 29.667)"
                    width="48.2083"
                />
            </clipPath>
        </defs>
    </svg>
);

export const GenerosityIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={Generosity}
        fontSize={fontSize}
    />
);
